const SizeClassCorrespondance = {
    'xs': 'ExtraSmallWidth',
    's': 'SmallWidth',
    'm': 'MediumWidth',
    'l': 'FullWidth',
    'regular': ''
  };

export default SizeClassCorrespondance